import styled from "styled-components";

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  max-height: calc(100vh - 355px);
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: 100%;

  & > * {
    min-width: 0;
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 744px) {
    grid-template-columns: 1fr;
  }
`;

export const ErrorWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white};
  margin: 0 auto;
`;
